export default "__VITE_ASSET__5d3fc7a4__"